(function () {
  "use strict";
  var pdp = document.getElementById("pdp"),
    dataEl = document.getElementById("pdpData");
  if (!pdp || !dataEl) return;
  var D = JSON.parse(dataEl.textContent),
    slides = Array.prototype.slice.call(pdp.querySelectorAll(".pdp-slide")),
    dots = Array.prototype.slice.call(pdp.querySelectorAll(".pdp-dot")),
    track = document.getElementById("pdpSlides");
  function setDot(i) {
    dots.forEach(function (d, j) {
      d.classList.toggle("on", j === i);
    });
  }
  if ("IntersectionObserver" in window && slides.length > 1) {
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          e.isIntersecting && setDot(parseInt(e.target.getAttribute("data-i"), 10));
        });
      },
      { root: null, threshold: 0.55 }
    );
    slides.forEach(function (s) {
      io.observe(s);
    });
  }
  function goTo(i) {
    var s = slides[i];
    s &&
      (track && track.scrollWidth > track.clientWidth + 4
        ? track.scrollTo({
            left: s.offsetLeft - track.offsetLeft,
            behavior: "smooth",
          })
        : window.scrollTo({
            top: s.getBoundingClientRect().top + window.pageYOffset - 90,
            behavior: "smooth",
          }));
  }
  dots.forEach(function (d, i) {
    d.addEventListener("click", function () {
      goTo(i);
    });
  }),
    track &&
      track.addEventListener(
        "scroll",
        function () {
          track.scrollWidth <= track.clientWidth + 4 ||
            setDot(
              Math.round(track.scrollLeft / Math.max(1, track.clientWidth))
            );
        },
        { passive: !0 }
      );
  var selects = Array.prototype.slice.call(
      pdp.querySelectorAll("select[data-opt]")
    ),
    idInput = document.getElementById("pdpVariant"),
    priceEl = document.getElementById("pdpPrice"),
    compareEl = document.getElementById("pdpCompare"),
    atc = document.getElementById("pdpAtc"),
    atcText = document.getElementById("pdpAtcText"),
    atcPrice = document.getElementById("pdpAtcPrice"),
    buy = document.getElementById("pdpBuy"),
    msg = document.getElementById("pdpMsg");
  function chosen() {
    return selects.map(function (s) {
      return s.value;
    });
  }
  function findVariant(vals) {
    for (var i = 0; i < D.variants.length; i++) {
      for (
        var v = D.variants[i], ok = !0, j = 0;
        j < vals.length;
        j++
      )
        if (v.options[j] !== vals[j]) {
          ok = !1;
          break;
        }
      if (ok) return v;
    }
    return null;
  }
  function markAvailability() {
    var vals = chosen();
    selects.forEach(function (s, idx) {
      Array.prototype.forEach.call(s.options, function (o) {
        var test = vals.slice();
        test[idx] = o.value;
        var v = findVariant(test),
          sold = !v || !v.available;
        o.textContent = o.value + (sold ? " (sold out)" : "");
      });
    });
  }
  function update() {
    var vals = chosen();
    selects.forEach(function (s, i) {
      var face = pdp.querySelector('[data-face="' + i + '"]');
      face && (face.textContent = s.value);
    });
    var v = findVariant(vals);
    if (((msg.textContent = ""), !v)) {
      (atc.disabled = !0),
        (buy.disabled = !0),
        (atcText.textContent = "Unavailable");
      return;
    }
    (idInput.value = v.id),
      (priceEl.textContent = v.price),
      (atcPrice.textContent = v.price),
      v.compare
        ? ((compareEl.textContent = v.compare), (compareEl.hidden = !1))
        : (compareEl.hidden = !0),
      (atc.disabled = !v.available),
      (buy.disabled = !v.available),
      (atcText.textContent = v.available ? "Add to cart" : "Sold out"),
      v.media != null && slides[v.media] && goTo(v.media);
    try {
      var u = new URL(location.href);
      u.searchParams.set("variant", v.id),
        history.replaceState(null, "", u.toString());
    } catch (e) {}
    markAvailability();
  }
  selects.forEach(function (s) {
    s.addEventListener("change", update);
  }),
    markAvailability();
  var qty = document.getElementById("pdpQty");
  pdp.querySelectorAll("[data-q]").forEach(function (b) {
    b.addEventListener("click", function () {
      var n = Math.min(
        10,
        Math.max(
          1,
          (parseInt(qty.value, 10) || 1) +
            parseInt(b.getAttribute("data-q"), 10)
        )
      );
      qty.value = n;
    });
  });
  function add() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(idInput.value, 10),
            quantity: parseInt(qty.value, 10) || 1,
          },
        ],
      }),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function refreshCount() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        var el = document.getElementById("cartCount");
        el &&
          ((el.textContent = c.item_count),
          el.classList.toggle("zero", !c.item_count),
          el.classList.remove("bump"),
          el.offsetWidth,
          el.classList.add("bump"));
      });
  }
  document.getElementById("pdpForm").addEventListener("submit", function (e) {
    e.preventDefault();
    if (atc.disabled) return;
    atc.classList.add("busy");
    add()
      .then(function () {
        atcText.textContent = "Added";
        msg.innerHTML =
          'Added to your cart. <a href="' + D.cartUrl + '">View cart</a>';
        return refreshCount();
      })
      .catch(function (err) {
        msg.textContent =
          (err && (err.description || err.message)) ||
          "Could not add this item. Please try again.";
      })
      .finally(function () {
        atc.classList.remove("busy");
        setTimeout(function () {
          atc.disabled || (atcText.textContent = "Add to cart");
        }, 1800);
      });
  });

  buy.addEventListener("click", function (e) {
    if (buy.disabled) return;
    buy.classList.add("busy");
    add()
      .then(function () {
        refreshCount();
        function openMagic() {
          var fn =
            window.openRzpCheckout ||
            (window.RazorpayMagicCheckout &&
              window.RazorpayMagicCheckout.openRzpCheckout);
          if (typeof fn === "function") {
            buy.classList.remove("busy");
            try {
              fn(e);
            } catch (err) {
              console.error("Razorpay open error:", err);
              window.location.href = "/checkout";
            }
            return true;
          }
          return false;
        }

        if (!openMagic()) {
          var retries = 0;
          var poll = setInterval(function () {
            retries++;
            if (openMagic() || retries >= 15) {
              clearInterval(poll);
              if (retries >= 15) {
                buy.classList.remove("busy");
                window.location.href = "/checkout";
              }
            }
          }, 200);
        }
      })
      .catch(function (err) {
        buy.classList.remove("busy");
        msg.textContent =
          (err && (err.description || err.message)) ||
          "Could not add this item. Please try again.";
      });
  });

  var more = document.getElementById("pdpMore"),
    aside = document.getElementById("pdpAside");
  more &&
    aside &&
    more.addEventListener("click", function () {
      window.scrollTo({
        top: aside.getBoundingClientRect().top + window.pageYOffset - 90,
        behavior: "smooth",
      });
    });
})();
